cliente.component('layoutComponent', {
    templateUrl: 'components/layout/layout.html',
    controller: 'layoutComponentController'
});

cliente.controller('layoutComponentController', ['$state', 'coreLanguage', 'coreAvisos', 'coreFb', '$filter', function($state, $text, $avisos, $fb, $filter) {
    const $ctrl = this;

    $ctrl.showMenu = () => $state.params.showMenu != false;
    $ctrl.hideNav = () => $state.params.hideNav == true;

    $ctrl.menuItems = [
        {
            title: $text.menu.home,
            route: 'cliente.inicio',
            icon: 'home'
        },
        /* {
            title: $text.menuClient.accelerator,
            route: 'cliente.acelerador',
            icon: 'chat_info'
        }, */
        {
            title: $text.menuClient.community,
            route: 'cliente.comunidade',
            icon: 'social_leaderboard'
        },
        {
            title: $text.menuClient.support,
            route: 'cliente.ajuda',
            icon: 'support_agent'
        }
        /* {
            title: $text.menuClient.partners,
            route: 'cliente.emBreve',
            icon: 'trophy'
        } */
    ];

    const _readAllAvisos=(avisos)=>{

        let readed = {};
        avisos.forEach(item=>{ readed[item.id] = true; });

        $fb.db.update(`idx_usuario_avisos/${$ctrl.idUsuario}`, readed).then(okay=>{
            $avisos.hide();

        }).catch(e=>{
            console.log(e);
        });
    };

    const _getAvisos=async(usuario)=>{

        let userRead = await $fb.db.get(`idx_usuario_avisos/${usuario.id}`);

        if(!userRead.data){
            await $fb.db.set(`idx_usuario_avisos/${usuario.id}`, {});
        }

        let list = await $fb.db.list('cad_avisos', [{where:['dataCadastro', '>=', usuario.lastLogin]}, {where:['nivel', '==', usuario.nivel]}, {orderBy:['dataCadastro']}]);

        let avisos = [];

        for(let item of list){
            if(!userRead.data || !userRead.data[item.id]){
                item.data.criacao.data = item.data.criacao.data.toDate();
                avisos.push(item);
            }
        }
            
        $avisos.show($filter('orderBy')(avisos, 'data.criacao.data'), _readAllAvisos);

        return;
    };

    const _getUser=(idUsuario)=>{
        $ctrl.usuario = {};

        $fb.db.get(`cad_usuarios/${idUsuario}`).then(userDoc=>{
            $ctrl.usuario = {
                id: idUsuario,
                nome: userDoc.data.nome,
                fotoUrl: userDoc.data.fotoUrl,
                nivel: 'starter', /// Obter nível
                lastLogin: new Date(2024, 0, 1)
            };

            _getAvisos($ctrl.usuario);

        });
    };

    const _checkItems=()=>{
        if(!$fb.auth.getIdToken().claims.idAreaMembros){$fb.auth.logout().then(()=>{ $state.reload(); });}

        let isPro = APP_CONSTANTS.APP_CONFIG.idPro === $fb.auth.getIdToken().claims.idAreaMembros;

        if(!isPro){
            //$ctrl.menuItems[1].route = false;
            //$ctrl.menuItems[2].route = false;
            //$ctrl.menuItems[3].route = false;
        }
    };

    $ctrl.$onInit=()=>{
        $ctrl.idUsuario = $fb.auth.getIdToken().claims.idUsuario;
        _getUser($ctrl.idUsuario);

        _checkItems();
    };

}]);